import { inject, provideAppInitializer } from '@angular/core';
import type { EnvironmentProviders } from '@angular/core';
import { catchError, firstValueFrom, of } from 'rxjs';

import { AuthActionsFacade } from './state/auth.actions.facade';
import { SecureAuthStorageService } from './services/secure-auth-storage/secure-auth-storage.service';

export function provideAuthHydration(): EnvironmentProviders {
  // Runs before routing starts. Angular awaits the returned Promise, so guards
  // always see a fully hydrated store — no redirect-to-login flash on refresh.
  return provideAppInitializer(async () => {
    const storage = inject(SecureAuthStorageService);
    const actionsFacade = inject(AuthActionsFacade);

    const data = await firstValueFrom(
      storage.load().pipe(catchError(() => of(null))),
    );
    if (!data) return;

    const { user, rememberMe, impersonatedBuyer } = data;
    actionsFacade.rehydrate({ user, rememberMe });

    if (impersonatedBuyer) {
      actionsFacade.rehydrateImpersonation(impersonatedBuyer);
    }
  });
}
